import { DbKey, WithDbId } from '../../../../../adl-gen/common/db';
import { Quiz, UserQuiz } from '../../../../../adl-gen/totalinteraction/futurefit/db';
// import { AppUserListEntry } from "../../../../../adl-gen/totalinteraction/futurefit/frontend";
import { ListFieldInfo } from '../../../common/list/list-types';

import { QuizListEntry, UserGroupListEntryWithQuizChanges } from './quiz-list-view';

// import { QuizListEntry } from "./quiz-list-view";

export type UserQuizListEntry = { id: DbKey<UserQuiz>; refId: DbKey<Quiz>; title: string } & Pick<
  UserQuiz,
  'startedAt' | 'completedAt'
>;

export const UserQuizListView: ListFieldInfo<UserQuizListEntry, QuizListEntry[]>[] = [
  {
    name: 'title',
    label: 'Title',
    kind: 'mapped',
    map: entry => entry.title,
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'startedAt',
    label: 'Started at',
    kind: 'instant',
    displayed: true,
    sortable: true,
    align: 'centre'
  },
  {
    name: 'completedAt',
    label: 'Completed at',
    kind: 'instant',
    displayed: true,
    sortable: true,
    align: 'centre'
  },
  {
    name: 'lockResults',
    label: 'Results Locked',
    kind: 'checkItem',
    toggle: (entry, list) => {
      if (list) {
        const quiz = list.find(q => q.id === entry.refId);
        return quiz ? quiz.lockResults : false;
      }
      return false;
    },
    displayed: true,
    align: 'centre'
  },
  {
    name: 'delete',
    label: 'Delete',
    kind: 'delete',
    displayed: true,
    align: 'centre'
  }
];

export const UserQuizListSummaryView: ListFieldInfo<QuizListEntry, UserGroupListEntryWithQuizChanges>[] = [
  {
    name: 'title',
    label: 'Title',
    kind: 'mapped',
    map: entry => entry.title,
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'lockResults',
    label: 'Results Locked',
    kind: 'checkItem',
    displayed: true,
    align: 'centre'
  },
  {
    // ----- [ TODO: ] -------------------------------------------------------------
    // TODO: Coordinate with newly-added group members (assignUser 'create' records)
    name: 'groupCount',
    label: 'Total in Group',
    kind: 'mapped',
    map: (_entry, data) => (data && data.members ? data.members.length : 0),
    displayed: true,
    sortable: false,
    align: 'centre'
  },
  {
    // ----- [ TODO: ] -------------------------------------------------------------
    // TODO: Coordinate with newly-added group members (assignUser 'create' records)
    // TODO: who might have already been allocated quizzes
    name: 'allocatedCount',
    label: 'Total Allocated',
    kind: 'mapped',
    // Just get one each for each user
    map: (entry, data) => {
      if (data) {
        const memberIds = data.members ? data.members.map(m => m.value.appUserId) : [];
        const uqAppUserIdsForQuiz = data.updates
          .filter(upd => upd.kind === 'loaded' || upd.kind === 'update' || upd.kind === 'create')
          .filter(
            upd =>
              ((upd.kind === 'loaded' || upd.kind === 'update') && upd.value.value.quizId === entry.id) ||
              (upd.kind === 'create' && upd.value === entry.id)
          )
          .reduce((acc: string[], next) => {
            if (next.kind === 'loaded' || next.kind === 'update') {
              if (memberIds.includes(next.value.value.appUserId)) {
                return acc.includes(next.value.value.appUserId) ? acc : [...acc, next.value.value.appUserId];
              }
            }
            if (next.kind === 'create' && next.userId) {
              if (memberIds.includes(next.userId)) {
                return acc.includes(next.userId) ? acc : [...acc, next.userId];
              }
            }
            return acc;
          }, []);
        return uqAppUserIdsForQuiz.length; // + creates.length
      }
      return 0;
    },
    displayed: true,
    sortable: false,
    align: 'centre'
  },
  {
    // ----- [ TODO: ] -------------------------------------------------------------
    // TODO: Coordinate with newly-added group members (assignUser 'create' records)
    // TODO: who might have already been allocated quizzes
    name: 'startedCount',
    label: 'Total Started',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        const memberIds = data.members ? data.members.map(m => m.value.appUserId) : [];
        const uqAppUserIdsForQuiz = data.updates
          .filter(upd => upd.kind === 'loaded' || upd.kind === 'update')
          .filter(upd => (upd.kind === 'loaded' || upd.kind === 'update') && upd.value.value.quizId === entry.id)
          .reduce((acc: WithDbId<UserQuiz>[], next) => {
            if (next.kind === 'loaded' || next.kind === 'update') {
              acc.push(next.value);
            }
            return acc;
          }, [])
          // get latest
          .sort((a, b) => {
            if (a.value.startedAt !== null && b.value.startedAt !== null) {
              return a.value.startedAt > b.value.startedAt ? 1 : a.value.startedAt < b.value.startedAt ? -1 : 0;
            }
            return 0;
          })
          // Unique for each user
          .reduce(
            (acc: WithDbId<UserQuiz>[], next) =>
              acc.find(uq => uq.value.appUserId === next.value.appUserId) ? acc : [...acc, next],
            []
          )
          .filter(uq => uq.value.startedAt !== null)
          .map(uq => uq.value.appUserId)
          .reduce((acc: string[], next) => (memberIds.includes(next) ? [...acc, next] : acc), []);
        return uqAppUserIdsForQuiz.length;
      }
      return 0;
    },
    displayed: true,
    sortable: false,
    align: 'centre'
  },
  {
    // ----- [ TODO: ] -------------------------------------------------------------
    // TODO: Coordinate with newly-added group members (assignUser 'create' records)
    // TODO: who might have already been allocated quizzes
    name: 'completedCount',
    label: 'Total Completed',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        const memberIds = data.members ? data.members.map(m => m.value.appUserId) : [];
        const uqAppUserIdsForQuiz = data.updates
          .filter(upd => upd.kind === 'loaded' || upd.kind === 'update')
          .filter(upd => (upd.kind === 'loaded' || upd.kind === 'update') && upd.value.value.quizId === entry.id)
          .reduce((acc: WithDbId<UserQuiz>[], next) => {
            if (next.kind === 'loaded' || next.kind === 'update') {
              acc.push(next.value);
            }
            return acc;
          }, [])
          // get latest
          .sort((a, b) => {
            if (a.value.completedAt !== null && b.value.completedAt !== null) {
              return a.value.completedAt > b.value.completedAt ? 1 : a.value.completedAt < b.value.completedAt ? -1 : 0;
            }
            return 0;
          })
          // Unique for each user
          .reduce(
            (acc: WithDbId<UserQuiz>[], next) =>
              acc.find(uq => uq.value.appUserId === next.value.appUserId) ? acc : [...acc, next],
            []
          )
          .filter(uq => uq.value.completedAt !== null)
          .map(uq => uq.value.appUserId)
          .reduce((acc: string[], next) => (memberIds.includes(next) ? [...acc, next] : acc), []);
        return uqAppUserIdsForQuiz.length;
      }
      return 0;
    },
    displayed: true,
    sortable: false,
    align: 'centre'
  }
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/quiz-list/user-quiz-list-view.ts